import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { refreshAccessTokenSuccess, resetLogoutFlag } from '../../redux/slices/authSlice';
import { jwtDecode } from "jwt-decode";
import { useRefreshTokenMutation } from '../../redux/slices/authApiSlice';
import { handleLogout } from '../../services/authService';
import { CustomLoader } from '../../components';

const PrivateRoute = () => {
  const userInfo = useSelector((state) => state?.auth?.userInfo);
  const accessToken = useSelector((state) => state?.auth?.accessToken);
  const logoutInitiated = useSelector((state) => state?.auth?.logoutInitiated);
  const dispatch = useDispatch();
  const [refreshToken, { isLoading }] = useRefreshTokenMutation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isTokenExpired = (token) => {
      if (!token) return true;

      try {
        const decodedToken = jwtDecode(token);
        const expirationBuffer = 10;
        const currentTime = Math.floor(Date.now() / 1000);
        return decodedToken.exp - currentTime < expirationBuffer;
      } catch (error) {
        return false;
      }
    };

    const refreshAccessToken = () => async () => {
      try {
        const res = await refreshToken().unwrap();

        if (res.status === 200) {
          dispatch(refreshAccessTokenSuccess({ accessToken: res.access_token }));
        }
        
      } catch (error) {
        handleLogout(dispatch);
      } finally {
        setLoading(false);
      }
    };

    if (accessToken && isTokenExpired(accessToken)) {
      dispatch(refreshAccessToken());
    } else {
      setLoading(false);
    }
  }, [accessToken, dispatch, refreshToken]);

  const notify = () => {
    toast.error('You need to be logged in to access this page.');
  };

  if (loading || isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <CustomLoader />
      </div>
    );
  }

  if (!accessToken || !userInfo) {
    if (!logoutInitiated) {
      toast.error('You need to be logged in to access this page.');
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
export default PrivateRoute;
